<div id="iris-logo">
  <a href="https://www.earthscope.org/">
    <img src="assets/sage_web_white.svg" alt="earthscope logo">
  </a>
</div>
<app-settings *ngIf="showUI" (showSettings)="showUI= false"></app-settings>
<div id="loading-screen" *ngIf="firstLoad">
  <div style="margin-top:35vh; text-align:center;">
    <img src="assets/sage_web_white.svg" alt="earthscope logo" style="height: 6em;">
    <h1>{{'map.title' | translate}}</h1>
    <img src="assets/icons/download.gif" alt="" style="height: 1em; margin-bottom: 0.5em;">
    <div *ngFor="let item of eventsService.status">{{item}}</div>
  </div>
</div>
<div id="region-name">
  <h1>{{regionName}}</h1>
</div>
<div id="latest-list" [class]="settingsService.settings.tablePosition" [style.display]="distractionFree?'none':'block'">
  <table class="events-table">

    <tr *ngFor="let e of latestEvents" [ngStyle]="{color: eventsService.getColorFromAge(e)}">
      <td class="t-mag">M {{e.magnitude | number:'1.1-1'}} </td>
      <td class="t-region" [ngSwitch]="settingsService.settings.dateType">
        <span *ngSwitchCase="'absolute'">{{e.time | date:'short'}}</span>
        <span *ngSwitchCase="'relative'">{{e.time | timeago}}</span>
      </td>
      <!-- <td class="t-region">{{e.time | date:'short'}}</td> -->
      <td>{{getRegionName(e.eventLocationName)}}</td>
    </tr>
  </table>

  <h3 *ngIf="latestEvents.length === 0">{{'map.no_events_found' | translate}}</h3>
  <div style="text-align: center">
    <div id="list-legend">
      <h3>{{'map.last' | translate}}:</h3>
      <h3 *ngFor="let color of settingsService.settings.getColorPallet().colors; index as i" [ngStyle]="{color: color}">
        {{colorLegend[i]}}</h3>
      <img class="settings-button" src="assets/icons/settings.png" alt="" (click)="showUI = !showUI"
        [ngClass]="{'settings-button-active': showUI}">
    </div>
  </div>
</div>

<div *ngIf="region.miniMapUrl" id="mini-map" [style.display]="distractionFree?'none':'block'"
  [class]="settingsService.settings.tablePosition">
  <div style="color: white;" (click)="showLatest()">
    {{'map.updated' | translate}} {{eventsService.lastUpdated | timeago}}
  </div>
  <img [src]="region.miniMapUrl" alt="">
</div>

<canvas #imageCanvas width="800" height="600"></canvas>
<app-animated-quakes [width]="canvas.width" [height]="canvas.height" [animateEvents]="latestEvents" [region]="region">
</app-animated-quakes>


<div id="progress-load" [ngStyle]="{width: progressWith}"></div>
